import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-publish",
  templateUrl: "./med-icon-publish.component.html",
})
export class MedIconPublishComponent extends SvgMixinComponent {}
